module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter-no",
    attrs: {
      "id": "ch-14"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_vm._v("14")])]), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IBOR HAS TIME ON HIS HANDS")]), _vm._v(" in London. He once lived here, came here as a young man escaping problems in his own Bulgaria, and London is where he met Bridget, one afternoon at a gymnasium where he was earning pocket money coaching soccer. He had seen her standing in the vestibule and hesitated to approach her, not because he lacked the confidence to do so but because she was so much younger than he was, but he went up to her anyway, and in the end it was a split-second decision that changed everything, including where he ended up living his life. I was already in America then and on my way to citizenship, and when I suggested that I might petition for them in case they ever wanted to join me, it seemed a practical idea, something to keep open. Then somehow, after the fingerprinting and the headache of getting birth certificates from Bulgaria and South Africa, and the x-rays and the police letters, when the approval came through it was as if the decision to move had already been made.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("According to Bridget, each morning when I am not in London Tibor follows exactly the same routine. He goes for a walk along the Brompton Road and stops in at the same tea shop. When he gets to Arnold’s Bridget will have been there for a couple of hours already, supervising my mother’s breakfast and morning bath, and while there is not much he can do to make himself useful Bridget wants him close by in case she needs him.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_45"
    }
  }), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_vm._v("It is while sitting in the quiet flat, interrupted only by the nurses coming and going at the changes in their shifts, or by Bridget walking to the kitchen, that Tibor begins to wonder what we will do with Helga’s possessions when this is all over. It is not that he wants anything, far from it, but he is a practical man and he has no doubt that when the time comes the task of sorting out, of packing and wrapping and shipping, will be his.")])]), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Do you know for sure what is hers?” he asks Bridget, gesturing around the room.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Of course,” Bridget says. “Every last piece. Danny can even tell you where they once stood at Gordonwood.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“And we’re taking it all back to America?” Tibor asks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“You’re more convinced than we are that Arnold will part with anything,” she says. “Danny’s convinced he won’t. I don’t know what the heck to think.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“But they’re yours,” Tibor says, and his wife looks at him with an expression that suggests he is either too logical or too innocent.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Tibor wasn’t sure whether what he saw justified our concern. The massive tusks were imposing, of course, in a league of their own, but beyond them my father’s collection seemed to him to be both odd and oddly random. It consisted of things like leather sandals so worn they defied appreciation, bits of spearhead, animal skins decorated with crusty brown baubles, pieces of beaded cloth, dozens of strange little statuettes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Do you even know what all of this is?” Tibor asks. “Or why anyone would want them?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Danny does,” Bridget answers. “My Dad used to go on and on about it.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1dc998a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/021_Chapter14.vue
// module id = 123
// module chunks = 0